import React from "react";
import './yourJourney.css';
import firebase from '../../firebase';
import config from "../../config/config";

class YourJourney extends React.Component {
    constructor(props) {
        super(props);

        this.ref = firebase.firestore().collection(config.shareYourJourneyPath);

        this.state = {
            isLoading: false,
            employmentStatus: 'true',
            fullName: '',
            phoneNumber: '',
            emailId: '',
            yearOfGraduation: '',
            streamOfStudy: '',
            otherStreamOfStudy: '',
            branchOfStudy: '',
            otherBranchOfStudy: '',
            collegeOfStudy: '',
            employedOrganization: '',
            yearOfEmployment: '',
            jobTitle: '',
            payPackage: '',
            payPackageDisclose: true,
            otherEmploymentStatus: '',
            careerPathReasons: '',
            errors: {},
            formIsValid: true,
            errorMsg: 'Please fill all the details',
            successMsg: ''
        };
    }

    validateForm() {
        let formIsValid = true;
        let errors = {};

        if(this.state.fullName === ''){
            formIsValid = false;
            errors["fullName"] = "*Please enter your Full Name";
        } else {
            if(!this.state.fullName.match(/^[a-zA-Z ]*$/)){
                formIsValid = false;
                errors["fullName"] = "*Please enter alphabet characters only";
            }
        }

        if(this.state.emailId === ''){
            formIsValid = false;
            errors["emailId"] = "*Please enter your Email id";
        } else {
            const pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(this.state.emailId)) {
                formIsValid = false;
                errors["emailId"] = "*Please enter valid Email id";
            }
        }

        if(this.state.phoneNumber === ''){
            formIsValid = false;
            errors["phoneNumber"] = "*Please enter your Phone Number";
        } else {
            if (!this.state.phoneNumber.match(/^[0-9]{10}$/)) {
                formIsValid = false;
                errors["phoneNumber"] = "*Please enter valid 10 digit phone number";
            }
        }

        if(this.state.careerPathReasons === ''){
            formIsValid = false;
            errors["careerPathReasons"] = "*Please enter your thought process in choosing your career path";
        }

        if(this.state.yearOfGraduation === ''){
            formIsValid = false;
            errors["yearOfGraduation"] = "*Please enter your year of graduation";
        }
        if(this.state.streamOfStudy === ''){
            formIsValid = false;
            errors["streamOfStudy"] = "*Please enter your stream of study";
        } else {
            if(this.state.streamOfStudy === 'Other'){
                if(this.state.otherStreamOfStudy === ''){
                    formIsValid = false;
                    errors["otherStreamOfStudy"] = "*Please enter your stream of study";
                }
            }
        }

        if(this.state.branchOfStudy === ''){
            formIsValid = false;
            errors["branchOfStudy"] = "*Please enter your branch of study";
        } else {
            if(this.state.branchOfStudy === 'Other'){
                if(this.state.otherBranchOfStudy === ''){
                    formIsValid = false;
                    errors["otherBranchOfStudy"] = "*Please enter your branch of study";
                }
            }
        }

        if(this.state.collegeOfStudy === ''){
            formIsValid = false;
            errors["collegeOfStudy"] = "*Please enter your college of study";
        }

        if(this.state.employmentStatus === 'true'){
            if(this.state.employedOrganization === ''){
                formIsValid = false;
                errors["employedOrganization"] = "*Please enter your current Organisation of Employment";
            }
            if(this.state.yearOfEmployment === ''){
                formIsValid = false;
                errors["yearOfEmployment"] = "*Please enter your year of Employment in current organisation";
            }
            if(this.state.jobTitle === ''){
                formIsValid = false;
                errors["jobTitle"] = "*Please enter your job title in current Organisation";
            }

            if(this.state.payPackageDisclose === true){
                if(this.state.payPackage === ''){
                    formIsValid = false;
                    errors["payPackage"] = "*Please enter your package details";
                }
            }
        } else {
            if(this.state.otherEmploymentStatus === ''){
                formIsValid = false;
                errors["otherEmploymentStatus"] = "*Please enter your current status";
            }
        }

        this.setState({
            errors: errors,
            formIsValid: formIsValid
        });

        return formIsValid;
    }

    saveJourneyDetails = () => {
        if(this.validateForm()) {
            this.setState({
                isLoading: true,
            });
            this.ref.add({
                employmentStatus: this.state.employmentStatus,
                fullName: this.state.fullName,
                phoneNumber: this.state.phoneNumber,
                emailId: this.state.emailId,
                yearOfGraduation: this.state.yearOfGraduation,
                streamOfStudy: this.state.streamOfStudy,
                otherStreamOfStudy: this.state.otherStreamOfStudy,
                branchOfStudy: this.state.branchOfStudy,
                otherBranchOfStudy: this.state.otherBranchOfStudy,
                collegeOfStudy: this.state.collegeOfStudy,
                employedOrganization: this.state.employedOrganization,
                yearOfEmployment: this.state.yearOfEmployment,
                jobTitle: this.state.jobTitle,
                payPackage: this.state.payPackage,
                payPackageDisclose: this.state.payPackageDisclose,
                otherEmploymentStatus: this.state.otherEmploymentStatus,
                careerPathReasons: this.state.careerPathReasons
            }).then((docRef) => {
                this.setState({
                    isLoading: false,
                    employmentStatus: 'true',
                    fullName: '',
                    phoneNumber: '',
                    emailId: '',
                    yearOfGraduation: '',
                    streamOfStudy: '',
                    otherStreamOfStudy: '',
                    branchOfStudy: '',
                    otherBranchOfStudy: '',
                    collegeOfStudy: '',
                    employedOrganization: '',
                    yearOfEmployment: '',
                    jobTitle: '',
                    payPackage: '',
                    payPackageDisclose: true,
                    otherEmploymentStatus: '',
                    careerPathReasons: '',
                    successMsg: 'Your details are saved successfully. Thanks for sharing your thought process.'
                });
            })
                .catch((error) => {
                    console.error("Error saving details: ", error);
                    this.setState({
                        isLoading: false,
                        errorMsg: 'Error saving details, please try again later'
                    });
                });
        }
    };


    handleEmploymentStatusChange = event => {
        this.setState({employmentStatus: event.target.value});
    };

    handlePayPackageDiscloseChange = event => {
        this.setState({payPackageDisclose: !this.state.payPackageDisclose});
    };

    handleInputChange = event => {
        this.setState({[event.target.id]: event.target.value});
    };

    render() {
        return <div className="container" style={{paddingTop: "2em"}}>
            {this.state.isLoading ?
                <div id="overlay" className="spinner-border text-info" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
                : <div/>
            }
            <div className="container">
                <div className="row">
                    <h2>Share your Journey</h2> <br/>
                    <p className="lead">
                        Fill in the details of your journey and help upcoming graduates understand the importance of choosing a
                        career path!<br/>
                    </p>
                </div>
                <div className="row">
                    <h5>How this will help ?</h5>
                </div>
                <ul>
                    <li><p>Your success story can inspire someone to follow your steps and help design their life better.</p></li>
                </ul>
            </div>
            <hr/>
            <div className="container" style={{backgroundColor: "#f2f2f2", padding: ".75rem"}}>
                <div className="row d-flex justify-content-center">
                    <h4 className="page-header">Basic Details</h4> <br/>
                </div>
                <hr/>
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group float-label-control">
                            <input id="fullName" type="text" className="form-control" placeholder="Full Name (Firstname Lastname)"
                                   onChange={this.handleInputChange} value={this.state.fullName}/>
                            <div className="errorMsg">{this.state.errors.fullName}</div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group float-label-control">
                            <input id="phoneNumber" type="tel" className="form-control"
                                   placeholder="Phone Number (9876543210)"
                                   pattern="[0-9]{10}" maxLength="10" onChange={this.handleInputChange}
                                   value={this.state.phoneNumber}/>
                            <div className="errorMsg">{this.state.errors.phoneNumber}</div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="form-group float-label-control">
                            <input id="emailId" type="email" className="form-control" placeholder="Email id (something@example.com)"
                                   onChange={this.handleInputChange} value={this.state.emailId}/>
                            <div className="errorMsg">{this.state.errors.emailId}</div>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
            <div className="container">
                <table className="table table-striped">
                    <tbody>
                    <tr>
                        <td colSpan="1">
                            <h5 className="d-flex justify-content-center">I did my Graduation in ...</h5>
                            <hr/>
                            <form className="well form-horizontal">
                                <fieldset>
                                    <div className="form-group">
                                        <div className="col-md-8 inputGroupContainer">
                                            <div className="form-group">
                                                <label htmlFor="yearOfGraduation">Year of Graduation</label>
                                                <select className="form-control" id="yearOfGraduation"
                                                        onChange={this.handleInputChange}
                                                        value={this.state.yearOfGraduation}>
                                                    <option value="Select">Select</option>
                                                    <option value="2010">2010</option>
                                                    <option value="2011">2011</option>
                                                    <option value="2012">2012</option>
                                                    <option value="2013">2013</option>
                                                    <option value="2014">2014</option>
                                                    <option value="2015">2015</option>
                                                    <option value="2016">2016</option>
                                                    <option value="2017">2017</option>
                                                    <option value="2018">2018</option>
                                                    <option value="2019">2019</option>
                                                    <option value="2020">2020</option>
                                                    <option value="2021">2021</option>
                                                    <option value="2022">2022</option>
                                                    <option value="2023">2023</option>
                                                    <option value="2024">2024</option>
                                                    <option value="2025">2025</option>
                                                </select>
                                                <div className="errorMsg">{this.state.errors.yearOfGraduation}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="col-md-8 inputGroupContainer">
                                            <div className="form-group">
                                                <label htmlFor="streamOfStudy">Stream of Study</label>
                                                <select className="form-control" id="streamOfStudy"
                                                        onChange={this.handleInputChange}
                                                        value={this.state.streamOfStudy}>
                                                    <option value="Select">Select</option>
                                                    <option value="B.E/B.Tech">B.E/B.Tech</option>
                                                    <option value="M.E/M.Tech">M.E/M.Tech</option>
                                                    <option value="Diploma/Polytechnic">Diploma/Polytechnic</option>
                                                    <option value="B.Sc">B.Sc</option>
                                                    <option value="B.C.A">B.C.A</option>
                                                    <option value="M.Sc">M.Sc</option>
                                                    <option value="M.C.A">M.C.A</option>
                                                    <option value="Other">Other</option>
                                                </select>
                                                <div className="errorMsg">{this.state.errors.streamOfStudy}</div>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        this.state.streamOfStudy === 'Other' ?
                                            <div className="form-group">
                                                <div className="col-md-8 inputGroupContainer">
                                                    <div className="form-group">
                                                        <input
                                                            id="otherStreamOfStudy" name="otherStreamOfStudy"
                                                            placeholder="Stream of Study"
                                                            className="form-control" type="text"
                                                            onChange={this.handleInputChange}
                                                            value={this.state.otherStreamOfStudy}/>
                                                        <div className="errorMsg">{this.state.errors.otherStreamOfStudy}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div />
                                    }
                                    <div className="form-group">
                                        <div className="col-md-8 inputGroupContainer">
                                            <div className="form-group">
                                                <label htmlFor="branchOfStudy">Branch of Study</label>
                                                <select className="form-control" id="branchOfStudy"
                                                        onChange={this.handleInputChange}
                                                        value={this.state.branchOfStudy}>
                                                    <option value="Select">Select</option>
                                                    <option value="Computer Science">Computer Science</option>
                                                    <option value="Information Technology">Information Technology
                                                    </option>
                                                    <option value="Electronics & Communications">Electronics &
                                                        Communications
                                                    </option>
                                                    <option value="Electrical">Electrical</option>
                                                    <option value="Mechanical">Mechanical</option>
                                                    <option value="Civil">Civil</option>
                                                    <option value="Chemical">Chemical</option>
                                                    <option value="Bio Informatics">Bio Informatics</option>
                                                    <option value="Instrumentation">Instrumentation</option>
                                                    <option value="Petroleum">Petroleum</option>
                                                    <option value="Aeronautical">Aeronautical</option>
                                                    <option value="Mining">Mining</option>
                                                    <option value="Marine">Marine</option>
                                                    <option value="Automobile">Automobile</option>
                                                    <option value="Textile">Textile</option>
                                                    <option value="Other">Other</option>
                                                </select>
                                                <div className="errorMsg">{this.state.errors.branchOfStudy}</div>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        this.state.branchOfStudy === 'Other' ?
                                            <div className="form-group">
                                                <div className="col-md-8 inputGroupContainer">
                                                    <div className="form-group">
                                                        <input
                                                            id="otherBranchOfStudy" name="otherBranchOfStudy"
                                                            placeholder="Branch of Study"
                                                            className="form-control" type="text"
                                                            onChange={this.handleInputChange}
                                                            value={this.state.otherBranchOfStudy}/>
                                                        <div className="errorMsg">{this.state.errors.otherBranchOfStudy}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div />
                                    }
                                    <div className="form-group">
                                        <div className="col-md-8 inputGroupContainer">
                                            <div className="form-group">
                                                <label htmlFor="collegeOfStudy">College of Study</label>
                                                <input
                                                    id="collegeOfStudy" name="collegeOfStudy"
                                                    placeholder="College Name"
                                                    className="form-control" type="text"
                                                    onChange={this.handleInputChange}
                                                    value={this.state.collegeOfStudy}/>
                                                <div className="errorMsg">{this.state.errors.collegeOfStudy}</div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </form>
                        </td>
                        <td colSpan="1">
                            <h5 className="d-flex justify-content-center">I am now ...</h5>
                            <hr/>
                            <div className="form-group">
                                <div className="col-md-8 inputGroupContainer">
                                    <div className="form-group">
                                        <label htmlFor="employmentStatus">Are you employed ?</label>
                                        <select onChange={this.handleEmploymentStatusChange}
                                                className="form-control" id="employmentStatus"
                                                value={this.state.employmentStatus}>
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            {this.state.employmentStatus === 'true' ?
                                <div className="container">
                                    <div className="form-group">
                                        <div className="col-md-8 inputGroupContainer">
                                            <div className="form-group">
                                                <input
                                                    id="employedOrganization" name="employedOrganization"
                                                    placeholder="Present Company/Organization Name"
                                                    className="form-control" type="text"
                                                    onChange={this.handleInputChange}
                                                    value={this.state.employedOrganization}/>
                                                <div className="errorMsg">{this.state.errors.employedOrganization}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="col-md-8 inputGroupContainer">
                                            <div className="form-group">
                                                <input
                                                    id="yearOfEmployment" name="yearOfEmployment"
                                                    placeholder="Year of Joining"
                                                    className="form-control" type="text"
                                                    onChange={this.handleInputChange}
                                                    value={this.state.yearOfEmployment}/>
                                                <div className="errorMsg">{this.state.errors.yearOfEmployment}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="col-md-8 inputGroupContainer">
                                            <div className="form-group">
                                                <input
                                                    id="jobTitle" name="jobTitle"
                                                    placeholder="Job Title"
                                                    className="form-control" type="text"
                                                    onChange={this.handleInputChange}
                                                    value={this.state.jobTitle}/>
                                                <div className="errorMsg">{this.state.errors.jobTitle}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="col-md-8 inputGroupContainer">
                                            <div className="form-group">
                                                <input
                                                    id="payPackage" name="payPackage"
                                                    placeholder="Package (CTC in Lakhs)"
                                                    className="form-control" type="text"
                                                    onChange={this.handleInputChange}
                                                    value={this.state.payPackage}
                                                    disabled={!this.state.payPackageDisclose}/>
                                                <div className="errorMsg">{this.state.errors.payPackage}</div>
                                                <label><input
                                                    type="checkbox"
                                                    id="payPackageDisclose"
                                                    checked={!this.state.payPackageDisclose}
                                                    onChange={this.handlePayPackageDiscloseChange}
                                                /> Prefer not to disclose</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="container">
                                    <div className="form-group">
                                        <div className="col-md-8 inputGroupContainer">
                                            <div className="form-group">
                                                <label htmlFor="otherEmploymentStatus">I am currently </label>
                                                <select className="form-control" id="otherEmploymentStatus"
                                                        onChange={this.handleInputChange}
                                                        value={this.state.otherEmploymentStatus}>
                                                    <option value="Select">Select</option>
                                                    <option value="working on my own Venture">Working on my own
                                                        Venture
                                                    </option>
                                                    <option value="looking for an opportunity">Looking for an
                                                        opportunity
                                                    </option>
                                                    <option value="in my graduation (still a student)">in my graduation (still a student)</option>
                                                </select>
                                                <div className="errorMsg">{this.state.errors.otherEmploymentStatus}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <hr/>
            <div className="container">
                <div className="row d-flex justify-content-center">
                    <h4 className="page-header">I chose this career path because</h4> <br/>
                </div>
                <hr/>
                <div className="form-group">
                    <label htmlFor="careerPathReasons">Share your thought process (each statement on a new
                        line):</label>
                    <textarea className="form-control"
                              rows="5"
                              id="careerPathReasons"
                              value={this.state.careerPathReasons}
                              onChange={this.handleInputChange}
                              placeholder={"1. I got inspiration from someone in the family \n" +
                              "2. Most of my friends chose the same career path \n" +
                              "3. My teachers told me to choose this career path \n" +
                              "4. Write your own"}
                    />
                    <div className="errorMsg">{this.state.errors.careerPathReasons}</div>
                </div>
            </div>
            <div className="container d-flex justify-content-center">
                <button type="button" className="btn btn-success" onClick={this.saveJourneyDetails}>Submit my details</button>
            </div>
            <div className="container d-flex justify-content-center">
            {
                this.state.formIsValid ?
                    <div className="successMsg">{this.state.successMsg}</div>
                    :
                    <div className="errorMsg">{this.state.errorMsg}</div>
            }
            </div>
            <br/>
        </div>
    }
}

YourJourney.propTypes = {};

export default YourJourney;
